// 设备分析
import http from "@/jslibs/axios/http";

// 设备分析-数量、设备类型分布
export const deviceNumStats = (data) => http.post("/web/report/deviceNumStats", data);

// 售后统计
export const afterSaleStat = (data) => http.post("/web/report/afterSaleStat", data);

// 新增激活设备趋势
export const deviceActiveTrend = (data) => http.post("/web/report/deviceActiveTrend", data);